<template>
  <div>
    <!-- <b-table 
      :items="info" 
      small/> -->
    <b-button 
      v-if="deleteOption"
      :disabled="!canDelete"
      variant="danger" 
      class="btn-lg" 
      @click="() => deleteRelatie()"
    >
      <i class="fa fa-trash" />
      Verwijder
    </b-button>
  </div>
</template>
<script>
import { serviceMixin } from "../mixins/serviceMixin";

export default {
    name: 'RelatieOverview',
    components: {},
    mixins: [ serviceMixin],
    props: {
        relatie: {
            type: Object,
            default: () => {}
        },
        deleteOption: {
            type: Boolean,
            default: true
        },
        url: {
            type: String,
            default: null
        }
    },
    data() {
        return  {
            info: null
        }
    },
    computed: {
        total: function() {
        if (this.info == null) return 0;
        return this.info.reduce((acc, item) => acc + item.aantal, 0);
      },
      canDelete: function() {
        // alle aantallen komen op 0 uit
        if (this.info == null) return -1;
        return this.total == 0;
      }
    },
    watch: {},
    mounted () {
        this.getInfo();
        
    },
    methods: {
      deleteRelatie() {
      var vm = this;
      this.delete(this.url)
        .then(function(response) {
          console.log("Loaded", response.data);
          vm.$router.push({ name: "Relaties" });
        })
        .catch(function(error) {
          console.log("Error on Authentication", error);
        });
      },
      getInfo() {
        var vm =this;
        this.get(this.url + "/overview").then(function(response) {
          console.log(response);
          vm.info = response.data.info;
        });
      }
    }
          
}
</script>